module.exports = __webpack_public_path__ + "assets/img_sherry-lehmann.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_sherry-lehmann.jpg
 ** module id = 217
 ** module chunks = 1
 **/